import {Button, Card, Col, Container, Row, Spinner} from "reactstrap";
import {Link, useHistory, useParams} from "react-router-dom";
import {useEffect, useRef, useState} from "react";
import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  increment,
  limit,
  orderBy,
  query,
  startAfter,
  updateDoc,
  where,
} from "firebase/firestore";
import {firebaseConstants, getDb, multiselectDropdownStyle,} from "../../../util/Constants";
import DataTable from "react-data-table-component";
import moment from "moment";
import Multiselect from "multiselect-react-dropdown";
import _ from "lodash";
import {fileUpload} from "util/UploadUsers";

let timer = null;

const Users = (props) => {
  const [users, setUsers] = useState([]);
  const [activeUsers, setActiveUsers] = useState([]);
  const [userCount, setUserCount] = useState(0);
  const [activeUserCount, setActiveUserCount] = useState(0);
  const [loadingUsers, setLoadingUsers] = useState(true);
  const [levelsData, setLevelsData] = useState([]);
  const [departmentsData, setDepartmentsData] = useState([]);
  const [regionsData, setRegionsData] = useState([]);
  const [level, setLevel] = useState(null);
  const [department, setDepartment] = useState(null);
  const [regions, setRegions] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [lastVisible, setLastVisible] = useState(null);
  const [nameSearchData, setNameSearchData] = useState([]);
  const [emailSearchData, setEmailSearchData] = useState([]);
  const [cgpaSearchData, setCgpaSearchData] = useState([]);
  const [degreeSearchData, setDegreeSearchData] = useState([]);
  const [loadingSearchData, setLoadingSearchData] = useState(false);
  const [loading, setLoading] = useState(null);
  const [uploadFiles, setUploadFiles] = useState(null);
  const [loader, setLoader] = useState(false);
  const [city, setCity] = useState("");
  const [cities, setCities] = useState([]);
  const [registrationFields, setRegistrationFeilds] = useState([]);
  const [usersCount, setUsersCount] = useState(0);
  const [projectType, setProjectType] = useState("");
  const [deleteLoad, setDeleteLoad] = useState(false);
  const [gameLink, setGameLink] = useState("");
  const [clearFiltersData, setClearFiltersData] = useState(false);

  const db = getDb();
  const usersRef = collection(db, firebaseConstants.dbUsers);
  const utilRef = collection(db, firebaseConstants.dbUtil);
  const regionRef = collection(db, firebaseConstants.dbRegions);
  const departmentRef = collection(db, firebaseConstants.dbDepartments);
  const history = useHistory();
  const { eventId } = useParams();

  const searchByNameDropdown = useRef();
  const searchByEmailDropdown = useRef();
  const searchByCgpa = useRef();
  const searchByDegree = useRef();
  const levelDropdown = useRef();
  const departmentDropdown = useRef();
  const regionDropdown = useRef();
  const cityDropdown = useRef();
  const fileInputRef = useRef(null);

  useEffect(() => {
    console.log(activeUsers, "Active Users Use effect");
  }, [activeUsers]);

  useEffect(() => {
    if (props?.signedInUser?.usersCount) {
      setUsersCount(props?.signedInUser?.usersCount);
    }
    getMetaData().then((data) => {
      setLevelsData(data.levels);
      // setDepartmentsData(data.departments);
      // setRegionsData(data.regions);
    });
    getEventData().then((data) => {
      setRegistrationFeilds(data.registrationFields);
      setProjectType(data.projectType);
      setGameLink(data.gameLink);
      setDepartmentsData(data.departments);
      setRegionsData(data.region);
    });
    getAnalytics().then((data) => {
      setUserCount(data);
      setActiveUserCount(data);
    });
    // fetchRegions()
    // fetchDepartments()
  }, []);
  useEffect(async () => {
    const selectedName = searchByNameDropdown.current.getSelectedItems();
    const selectedEmail = searchByEmailDropdown.current.getSelectedItems();
    let selectedCgpa = "";
    let selectedDegree = "";
    if (registrationFields.includes("cgpa")) {
      selectedCgpa = searchByCgpa.current.getSelectedItems();
    }
    if (registrationFields.includes("degree")) {
      selectedDegree = searchByDegree.current.getSelectedItems();
    }
    if (
      selectedName.length === 0 &&
      selectedEmail.length === 0 &&
      selectedCgpa.length === 0 &&
      selectedDegree.length === 0
    ) {
      if (users.length < rowsPerPage * currentPage - rowsPerPage + 1) {
        await getUsers(true, false);
      } else {
        // await getUsers(true, false);

        setActiveUsers(
          users.slice(
            currentPage * rowsPerPage - rowsPerPage,
            currentPage * rowsPerPage
          )
        );
      }
    }
  }, [currentPage, rowsPerPage, clearFiltersData]);

  //changes by me
  const getEventData = async () => {
    const docRef = doc(db, "Events", eventId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      return data;
    }
  };
  // const fetchDepartments = async () => {
  //     const querySnapshot = await getDocs(departmentRef);
  //     let dataArr = []
  //     querySnapshot.forEach((doc) => {
  //         dataArr.push(
  //             {
  //                 department: doc.data().department,
  //             }
  //         )
  //     });
  //     setDepartmentsData(dataArr.map((e) => e.department));
  // }
  // const fetchRegions = async () => {
  //     const querySnapshot = await getDocs(regionRef);
  //     let dataArr = []
  //     querySnapshot.forEach((doc) => {
  //         dataArr.push(
  //             {
  //                 region: doc.data().region,
  //             }
  //         )
  //     })
  //     setRegionsData(dataArr.map((e) => e.region));
  // }
  const getMetaData = async () => {
    let dept = [],
      levels = [],
      regions = [];
    const docRef = doc(utilRef, "meta");
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      dept = data.departments ? data.departments : [];
      levels = data.levels ? data.levels : [];
      regions = data.regions ? data.regions : [];
    }

    return { departments: dept, levels: levels, regions: regions };
  };
  const getAnalytics = async () => {
    if (userCount) {
      return userCount;
    } else {
      let count = 0;
      const docRef = doc(usersRef, "analytics");
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        count = data[eventId];
      }

      return count;
    }
  };

  const getUsers = async (useLastVisible, useConstraints) => {
    const data = [],
      constraints = useConstraints ? getConstraints() : [],
      order = getOrder(useConstraints),
      limits = [];
    let q = null;

    if (constraints.length === 0) {
      limits.push(limit(rowsPerPage));
    }

    if (useLastVisible && lastVisible) {
      q = query(
        usersRef,
        where("eventId", "==", eventId),
        ...constraints,
        ...order,
        startAfter(lastVisible),
        ...limits
      );
    } else {
      q = query(
        usersRef,
        where("eventId", "==", eventId),
        ...constraints,
        ...order,
        ...limits
      );
    }
    const querySnapshot = await getDocs(q);
    setLastVisible(querySnapshot.docs[querySnapshot.docs.length - 1]);
    querySnapshot.docs.forEach((doc) => {
      data.push({ id: doc.id, ...doc.data() });
    });

    if (useConstraints) {
      setUsers(data);
      setActiveUsers(
        data.slice(
          currentPage * rowsPerPage - rowsPerPage,
          currentPage * rowsPerPage
        )
      );
      setActiveUserCount(data.length);
    } else {
      const count = await getAnalytics();
      setActiveUserCount(count);
      setUsers([...users, ...data]);
      setActiveUsers(data);
    }

    setNameSearchData(
      data.map((_data) => ({
        value: (
          <span>
            {_data.name} - <span className="">{_data.email}</span>
          </span>
        ),
        rank: 1,
        id: _data.id,
        ..._data,
      }))
    );

    setEmailSearchData(
      data.map((_data) => ({
        value: (
          <span>
            {_data.name} - <span className="">{_data.email}</span>
          </span>
        ),
        rank: 1,
        id: _data.id,
        ..._data,
      }))
    );
    //cgpa

    setCgpaSearchData([{ value: "1-2" }, { value: "2-3" }, { value: "3-4" }]);
    //degree

    const UniqueDegrees = data
      .map((_data) => ({
        value: (
          <span>
            {" "}
            <span className="">{_data.userInfo?.degree}</span>
          </span>
        ),
        rank: 1,
        id: _data.id,
        ..._data,
      }))
      .filter(
        (obj, index, self) =>
          index ===
          self.findIndex((t) => t.userInfo?.degree === obj.userInfo?.degree)
      )
      .filter((e) => e.userInfo);

    setDegreeSearchData(UniqueDegrees);

    setCities(
      data.map((e) => {
        if (e.userInfo !== undefined) {
          return e.userInfo.city;
        }
      })
    );
    setLoadingUsers(false);
  };

  const applyFilters = () => {
    setLoadingUsers(true);
    setLastVisible(null);
    setUsers([]);
    setActiveUsers([]);
    setActiveUserCount(0);
    searchByNameDropdown.current.resetSelectedValues();
    searchByEmailDropdown.current.resetSelectedValues();

    getUsers(false, true).then((r) => {});
  };

  const clearFilters = () => {
    setLevel(null);
    setDepartment(null);
    setRegions([]);
    setStartDate(null);
    setEndDate(null);
    setLoadingUsers(true);
    setLastVisible(null);
    setUsers([]);
    setActiveUsers([]);
    setActiveUserCount(1);
    setClearFiltersData(!clearFiltersData);
    setCurrentPage(1);

    // searchByNameDropdown.current.resetSelectedValues();
    // searchByEmailDropdown.current.resetSelectedValues();
    registrationFields.includes("department") &&
      departmentDropdown.current.resetSelectedValues();
    registrationFields.includes("region") &&
      regionDropdown.current.resetSelectedValues();

    // getUsers(false, false).then((r) => {});
  };

  useEffect(() => {
    console.log(users, activeUsers);
  }, [users, activeUsers]);

  const getConstraints = () => {
    const constraints = [];
    if (level) {
      constraints.push(where("currentLevel", "==", Number(level)));
    }
    if (department) {
      constraints.push(where("department", "==", department));
    }
    if (regions.length > 0) {
      constraints.push(where("region", "in", regions));
    }
    if (startDate) {
      constraints.push(where("lastUpdated", ">", startDate.valueOf()));
    }
    if (endDate) {
      constraints.push(where("lastUpdated", "<", endDate.valueOf()));
    }
    return constraints;
  };

  const getOrder = (useConstraints = true) => {
    if (useConstraints) {
      const order = [];
      if (startDate || endDate) {
        order.push(orderBy("lastUpdated"));
      }
      return order;
    } else {
      return [orderBy("name")];
    }
  };

  const handleSearch = async (searchText, searchBy) => {
    const constraints = getConstraints();
    let userData = [];
    let q;
    if (constraints.length > 0) {
      // constraints applied
      const unsortedData = users
        .filter((user) =>
          user[searchBy].toLowerCase().includes(searchText.toLowerCase())
        )
        .slice(0, 10)
        .map((user) => ({
          ...user,
          value: (
            <span>
              {user.name} - <span className="">{user.email}</span>
            </span>
          ),
        }));
      userData = _.orderBy(unsortedData, [searchBy], ["desc"]);
    } else {
      if (searchBy === "degree") {
        q = query(
          usersRef,
          where(`userInfo.degree_insensitive`, ">=", searchText.toLowerCase()),
          where("eventId", "==", eventId),
          orderBy(`userInfo.degree_insensitive`),
          limit(10)
        );
      } else {
        q = query(
          usersRef,
          where(`${searchBy}_insensitive`, ">=", searchText.toLowerCase()),
          where("eventId", "==", eventId),
          orderBy(`${searchBy}_insensitive`),
          limit(10)
        );
      }

      const querySnapshot = await getDocs(q);
      querySnapshot.docs.forEach((doc) => {
        const data = doc.data();
        userData.push(
          searchBy !== "degree"
            ? {
                value: (
                  <span>
                    {data.name} - <span className="">{data.email}</span>
                  </span>
                ),
                id: doc.id,
                ...data,
              }
            : {
                value: <span>{data.userInfo.degree}</span>,
                id: doc.id,
                ...data,
              }
        );
      });
    }

    if (searchBy === "degree") {
      userData = userData.filter((_data) =>
        _data.userInfo.degree_insensitive.startsWith(searchText.toLowerCase())
      );
      setDegreeSearchData(userData);
    } else {
      userData = userData.filter((_data) =>
        _data[`${searchBy}_insensitive`].startsWith(searchText.toLowerCase())
      );
      searchBy === "name"
        ? setNameSearchData(userData)
        : setEmailSearchData(userData);
    }
    setLoadingSearchData(false);
  };
  const removeSearch = (list, item) => {
    setActiveUsers(
      users.slice(
        currentPage * rowsPerPage - rowsPerPage,
        currentPage * rowsPerPage
      )
    );
    setActiveUserCount(userCount);
  };
  // asad changes

  const getUsersEmail = async (data) => {
    let emails = [];
    const emailsData = data.map((e, index) => e.email).filter((e) => e);

    const citiesRef = collection(db, "users");

    // batch size of 10
    const batchSize = 10;
    for (let i = 0; i < emailsData.length; i += batchSize) {
      const batch = emailsData.slice(i, i + batchSize);
      const q = query(
        citiesRef,
        where("email", "in", batch),
        where("eventId", "==", eventId)
      );
      const querySnapshot = await getDocs(q);
      const documents = querySnapshot.docs;

      if (documents) {
        documents.forEach((doc) => {
          const data = doc.data();
          emails.push(data.email);
        });
      }
    }
    return emails;
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    // setUploadFiles(file);
    console.log("1");
    setLoader(true);

    try {
      const count = await fileUpload(
        file,
        props.signedInUser?.maxUsers,
        props.signedInUser.uid,
        usersCount,
        eventId,
        db,
        gameLink,
        props.signedInUser
      );
      console.log(count);
      setUsersCount(count);
      fileInputRef.current.value = null; // Reset file input value
      console.log("2"); // Move the second console.log here, after the asynchronous operations
    } catch (error) {
      // Handle any errors that occurred during the asynchronous operations
    }
    setLoader(false);
    console.log("3");
  };

  const onSelectCgpa = async (item) => {
    let originalString = item.value;
    const hyphenIndex = originalString.indexOf("-");
    const value1 = originalString.substr(hyphenIndex - 1, 1);
    const value2 = originalString.substr(hyphenIndex + 1, 1);
    let userData = [];

    try {
      const populationQuery = query(
        usersRef,
        where("userInfo.cgpa", ">=", Number(value1)),
        where("userInfo.cgpa", "<=", Number(value2)),
        where("eventId", "==", eventId),
        limit(10)
      );
      const querySnapshot = await getDocs(populationQuery);

      querySnapshot.docs.forEach((doc) => {
        const data = doc.data();
        userData.push({
          value: (
            <span>
              {`${data.name} - `}
              <span className="user-id">{doc.id}</span>
            </span>
          ),
          id: doc.id,
          ...data,
        });
      });
      setActiveUsers(userData);
      setActiveUserCount(userData.length);
      // setUserCount(userData.length)
    } catch (error) {
      console.error(error);
    }
    searchByNameDropdown.current.resetSelectedValues();
    searchByEmailDropdown.current.resetSelectedValues();
    searchByDegree?.current?.resetSelectedValues();
  };

  const onSelectDegree = async (item) => {
    let str = item.userInfo.degree;

    let userData = [];

    try {
      const populationQuery = query(
        usersRef,
        where("userInfo.degree", "==", str),
        where("eventId", "==", eventId),
        limit(10)
      );
      const querySnapshot = await getDocs(populationQuery);

      querySnapshot.docs.forEach((doc) => {
        const data = doc.data();
        userData.push({
          value: (
            <span>
              {`${data.name} - `}
              <span className="user-id">{doc.id}</span>
            </span>
          ),
          id: doc.id,
          ...data,
        });
      });
      setActiveUsers(userData);
      setActiveUserCount(userData.length);
      // setUserCount(userData.length)
    } catch (error) {
      console.error(error);
    }
    searchByNameDropdown.current.resetSelectedValues();
    searchByEmailDropdown.current.resetSelectedValues();
    searchByCgpa?.current?.resetSelectedValues();
  };

  const checkProjectType = () => {
    return projectType === "progress";
  };

  return (
    <>
      <Container fluid>
        <h1 className="mb-0 custom-font letterSpacing">Filters</h1>
        <div className="mb-4">
          {checkProjectType() && (
            <Row>
              {registrationFields.includes("department") && (
                <Col md={2}>
                  {/* <h5 className="text-muted">Department</h5> */}
                  <Multiselect
                    ref={departmentDropdown}
                    className="form-control-alternative mb-1 filters-sub"
                    isObject={false}
                    showArrow={true}
                    selectionLimit={1}
                    placeholder="Department"
                    options={departmentsData}
                    closeIcon="cancel"
                    onSelect={(list, item) => setDepartment(item)}
                    onRemove={(list, item) => setDepartment(null)}
                    style={multiselectDropdownStyle}
                  />
                  <p className="mb-0 small text-muted float-right">
                    Single Select
                  </p>
                </Col>
              )}
              {registrationFields.includes("region") && (
                <Col md={2}>
                  {/* <h5 className="text-muted">Region</h5> */}
                  <Multiselect
                    ref={regionDropdown}
                    className="form-control-alternative mb-1 filters-sub"
                    isObject={false}
                    showArrow={true}
                    placeholder="Region"
                    options={regionsData}
                    closeIcon="cancel"
                    onSelect={(list, item) => setRegions([...regions, item])}
                    onRemove={(list, item) =>
                      setRegions(regions.filter((i) => i !== item))
                    }
                    style={multiselectDropdownStyle}
                  />
                  <p className="mb-0 small text-muted float-right">
                    Multi Select
                  </p>
                </Col>
              )}

              {registrationFields.includes("department") ||
              registrationFields.includes("region") ? (
                <Col md={3}>
                  <Button
                    color="primary"
                    disabled={
                      !level &&
                      !department &&
                      regions.length === 0 &&
                      !startDate &&
                      !endDate
                    }
                    onClick={applyFilters}
                  >
                    Apply
                  </Button>
                  <Button
                    color="danger"
                    disabled={
                      !level &&
                      !department &&
                      regions.length === 0 &&
                      !startDate &&
                      !endDate
                    }
                    onClick={clearFilters}
                  >
                    Clear
                  </Button>
                </Col>
              ) : null}
            </Row>
          )}

          <Row className="filters-bg ">
            <Col>
              <Multiselect
                className="form-control-alternative filters-sub"
                ref={searchByNameDropdown}
                // showArrow={true}
                hidePlaceholder={true}
                displayValue="value"
                selectionLimit={1}
                placeholder="Search by Name"
                options={nameSearchData}
                closeIcon="cancel"
                loading={loadingSearchData}
                onSelect={(list, item) => {
                  searchByEmailDropdown?.current?.resetSelectedValues();
                  searchByDegree?.current?.resetSelectedValues();
                  searchByCgpa?.current?.resetSelectedValues();

                  setActiveUsers([item]);
                  setActiveUserCount(1);
                }}
                onRemove={removeSearch}
                onSearch={(text) => {
                  clearTimeout(timer);
                  if (text.length >= 1) {
                    setLoadingSearchData(true);
                    timer = setTimeout(() => {
                      handleSearch(text, "name").then((r) => {});
                    }, 1000);
                  } else {
                    setLoadingSearchData(false);
                  }
                }}
                style={multiselectDropdownStyle}
              />
            </Col>
            <Col>
              <Multiselect
                className="form-control-alternative filters-sub"
                ref={searchByEmailDropdown}
                // showArrow={true}
                hidePlaceholder={true}
                displayValue="value"
                selectionLimit={1}
                placeholder="Search by Email"
                options={emailSearchData}
                closeIcon="cancel"
                loading={loadingSearchData}
                onSelect={(list, item) => {
                  searchByNameDropdown?.current?.resetSelectedValues();
                  searchByDegree?.current?.resetSelectedValues();
                  searchByCgpa?.current?.resetSelectedValues();
                  setActiveUsers([item]);
                  setActiveUserCount(1);
                }}
                onRemove={removeSearch}
                onSearch={(text) => {
                  // setEmailSearchData([]);
                  clearTimeout(timer);
                  if (text.length >= 1) {
                    setLoadingSearchData(true);
                    timer = setTimeout(() => {
                      handleSearch(text, "email").then((r) => {});
                    }, 1000);
                  } else {
                    setLoadingSearchData(false);
                  }
                }}
                style={multiselectDropdownStyle}
              />
            </Col>

            {/*cgpa and degree*/}
            {registrationFields.includes("cgpa") && !checkProjectType() && (
              <Col>
                <Multiselect
                  className="form-control-alternative filters-sub"
                  ref={searchByCgpa}
                  // showArrow={true}
                  hidePlaceholder={true}
                  displayValue="value"
                  selectionLimit={1}
                  placeholder="Search by CGPA"
                  options={cgpaSearchData}
                  closeIcon="cancel"
                  loading={loadingSearchData}
                  onSelect={(list, item) => onSelectCgpa(item)}
                  onRemove={removeSearch}
                  style={multiselectDropdownStyle}
                />
              </Col>
            )}
            {registrationFields.includes("degree") && !checkProjectType() && (
              <Col>
                <Multiselect
                  className="form-control-alternative filters-sub"
                  ref={searchByDegree}
                  // showArrow={true}
                  hidePlaceholder={true}
                  displayValue="value"
                  selectionLimit={1}
                  placeholder="Search by Degree"
                  options={degreeSearchData}
                  closeIcon="cancel"
                  loading={loadingSearchData}
                  onSelect={(list, item) => onSelectDegree(item)}
                  onRemove={removeSearch}
                  onSearch={(text) => {
                    // setEmailSearchData([]);
                    clearTimeout(timer);
                    if (text.length >= 1) {
                      setLoadingSearchData(true);
                      timer = setTimeout(() => {
                        handleSearch(text, "degree").then((r) => {});
                      }, 1000);
                    } else {
                      setLoadingSearchData(false);
                    }
                  }}
                  style={multiselectDropdownStyle}
                />
              </Col>
            )}
          </Row>
        </div>
        <Row className="mb-1">
          {props.signedInUser.role === "admin" && (
            <Col className="d-flex justify-content-end">
              <Link
                to={`/admin/users/new/${localStorage.getItem(
                  "eventId"
                )}`}
              >
                <Button color="" className="btnColor btnSecondary">
                  Add User
                </Button>
              </Link>
              <span>
                <label
                  disabled={loader}
                  htmlFor="imageUpload"
                  className={"btn btnColor custom-font  mb-0"}
                >
                  <i className="fa fa-upload mr-2" />
                  {loader ? "Loading..." : "Bulk Upload"}
                </label>
                <input
                  ref={fileInputRef}
                  onChange={handleFileUpload}
                  disabled={loader}
                  className="d-none"
                  id="imageUpload"
                  type="file"
                  accept=".csv"
                />
              </span>
            </Col>
          )}
        </Row>

        <Row className="mb-4 ">
          <Col>
            <Card>
              <DataTable
                columns={[
                  { name: "Name", wrap: true, selector: (row) => row.name },
                  { name: "Email", selector: (row) => row.email },
                  registrationFields.includes("department") &&
                    checkProjectType() && {
                      name: "Dept.",
                      width: "100px",
                      center: true,
                      selector: (row) => row.department,
                    },

                  registrationFields.includes("region") &&
                    checkProjectType() && {
                      name: "Region",
                      width: "100px",
                      center: true,
                      selector: (row) => row.region,
                    },
                  {
                    name: "Token Expiry",
                    center: true,
                    width: "150px",
                    selector: (row) => row.expiryDate,
                    cell: (row) => {
                      return (
                        <div className="text-center">
                          {row.canExpire ? (
                            //"yes expire"
                            row.expiryDate ? (
                              moment().isBefore(row.expiryDate) ? (
                                <div>
                                  {moment(row.expiryDate).format("DD/MMM/YYYY")}
                                </div>
                              ) : (
                                <div style={{ color: "red" }}>
                                  {moment(row.expiryDate).format("DD/MMM/YYYY")}
                                </div>
                              )
                            ) : (
                              // <i className="fas fa-check text-success"/> :
                              //<Button
                              //size="sm"
                              //color={ 'danger' }
                              //>
                              <i
                                className="fas fa-ban"
                                style={{ color: "red" }}
                              />
                            )
                          ) : (
                            //</Button>
                            // <i className="text-danger far fa-trash-alt"/>"no time stamp"
                            // <i className="fas fa-times text-danger"/>

                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              class="bi bi-infinity"
                              viewBox="0 0 16 16"
                            >
                              <path d="M5.68 5.792 7.345 7.75 5.681 9.708a2.75 2.75 0 1 1 0-3.916ZM8 6.978 6.416 5.113l-.014-.015a3.75 3.75 0 1 0 0 5.304l.014-.015L8 8.522l1.584 1.865.014.015a3.75 3.75 0 1 0 0-5.304l-.014.015L8 6.978Zm.656.772 1.663-1.958a2.75 2.75 0 1 1 0 3.916L8.656 7.75Z" />
                            </svg>
                          )}
                        </div>
                      );
                    },
                  },
                  {
                    name: "Active",
                    center: true,
                    width: "75px",
                    selector: (row) => row.isActive,
                    cell: (row) => {
                      return (
                        <div className="text-center">
                          {row.isActive ? (
                            <i className="fas fa-check text-success" />
                          ) : (
                            <i className="fas fa-times text-danger" />
                          )}
                        </div>
                      );
                    },
                  },

                  registrationFields.includes("institute") &&
                    !checkProjectType() && {
                      name: "Institute",
                      width: "100px",
                      center: true,
                      selector: (row) => row?.userInfo?.institute,
                    },
                  registrationFields.includes("cgpa") &&
                    !checkProjectType() && {
                      name: "CGPA",
                      width: "100px",
                      center: true,
                      selector: (row) => row?.userInfo?.cgpa,
                    },
                  registrationFields.includes("degree") &&
                    !checkProjectType() && {
                      name: "Degree",
                      width: "100px",
                      center: true,
                      selector: (row) => row?.userInfo?.degree,
                    },
                  registrationFields.includes("city") &&
                    !checkProjectType() && {
                      name: "City ",
                      width: "100px",
                      center: true,
                      selector: (row) => row?.userInfo?.city,
                    },
                  {
                    name: "Last Updated",
                    width: "150px",
                    selector: (row) => row.lastUpdated,
                    format: (row) =>
                      moment(row.lastUpdated).format("DD/MMM/YYYY, HH:MM"),
                  },
                  {
                    name: "",
                    center: true,
                    width: "150px",
                    selector: (row) => null,
                    cell: (row) =>
                      props.signedInUser.role === "admin" && (
                        <div>
                          {/*<Button*/}
                          {/*    color="primary"*/}
                          {/*    size="sm"*/}
                          {/*    onClick={() => history.push(`users/${row.id}`)}*/}
                          {/*>*/}
                          {/*    View*/}
                          {/*</Button>*/}
                          <Link
                            to={`${encodeURIComponent(row.id)}/edit`}
                            className="btn btn-primary btn-sm"
                          >
                            <i className="fas fa-pen" />
                          </Link>
                          {/*<Button*/}
                          {/*    color="primary"*/}
                          {/*    size="sm"*/}
                          {/*    onClick={() => history.push(`${row.id}/edit`)}*/}
                          {/*>*/}
                          {/*    <i className="fas fa-pen"/>*/}
                          {/*</Button>*/}
                          <Button
                            color={row.isActive ? "danger" : "success"}
                            size="sm"
                            disabled={loading === `blocking_${row.id}`}
                            onClick={async () => {
                              setLoading(`blocking_${row.id}`);
                              await updateDoc(doc(db, "users", row.id), {
                                isActive: !row.isActive,
                              });

                              const index = users.findIndex(
                                (obj) => obj.id === row.id
                              );
                              if (index >= 0) {
                                // loaded from DB
                                const data = users;
                                data[index].isActive = !data[index].isActive;
                                setUsers(data);

                                const _newActiveUsers = _.intersectionBy(
                                  data,
                                  activeUsers,
                                  "id"
                                );
                                setActiveUsers(_newActiveUsers);
                              } else {
                                const activeIndex = activeUsers.findIndex(
                                  (obj) => obj.id === row.id
                                );
                                const activeData = activeUsers;
                                activeData[activeIndex].isActive =
                                  !activeData[activeIndex].isActive;
                                setActiveUsers(activeData);
                              }

                              setLoading(null);
                            }}
                          >
                            {loading === `blocking_${row.id}` ? (
                              <Spinner
                                className="mx-2"
                                color={"white"}
                                size={"sm"}
                              >
                                Loading...
                              </Spinner>
                            ) : row.isActive ? (
                              <i className="fas fa-ban" />
                            ) : (
                              <i className="fas fa-undo" />
                            )}
                          </Button>
                          <Button
                            color="white"
                            size="sm"
                            disabled={deleteLoad}
                            onClick={async () => {
                              setLoading(`deleting_${row.id}`);
                              setDeleteLoad(true);

                              await deleteDoc(doc(db, "users", row.id));
                              await updateDoc(doc(db, "users", "analytics"), {
                                [eventId]: increment(-1),
                              });
                              await updateDoc(
                                doc(db, "admins", props.signedInUser.uid),
                                {
                                  usersCount: increment(-1),
                                }
                              );

                              const index = users.findIndex(
                                (obj) => obj.id === row.id
                              );
                              if (index >= 0) {
                                // loaded from DB
                                const data = users.filter(
                                  (_user) => _user.id !== row.id
                                );
                                console.log(data.length);
                                setActiveUserCount(activeUserCount - 1);

                                setUsers(data);
                                const _newActiveUsers = _.intersectionBy(
                                  data,
                                  activeUsers,
                                  "id"
                                );
                                setActiveUsers(_newActiveUsers);
                              } else {
                                const activeData = activeUsers.filter(
                                  (_user) => _user.id !== row.id
                                );
                                setActiveUsers(activeData);
                              }

                              setLoading(null);
                              setDeleteLoad(false);
                            }}
                          >
                            {loading === `deleting_${row.id}` ? (
                              <Spinner
                                className="mx-2"
                                color="dark"
                                size={"sm"}
                              >
                                Loading...
                              </Spinner>
                            ) : (
                              <i className="text-danger far fa-trash-alt" />
                            )}
                          </Button>
                        </div>
                      ),
                  },
                ].filter(Boolean)}
                data={activeUsers}
                progressPending={loadingUsers}
                pagination
                paginationTotalRows={activeUserCount}
                paginationServer={true}
                responsive
                persistTableHead
                highlightOnHover
                paginationRowsPerPageOptions={[10]}
                onChangePage={(page, totalRows) => {
                  setCurrentPage(page);
                }}
                onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                  setRowsPerPage(currentRowsPerPage);
                }}
              />
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Users;
